var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcheckallall = function SvgIconcheckallall(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/checkbox/checkall.all") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/checkbox/checkall.all",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    stroke: "#808080",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dash",
    opacity: 0,
    transform: "translate(5.500000, 11.500000)",
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.5,
    x2: 12.5,
    y2: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(6.155621, 7.399968)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2423792,0.303032408 C10.4359787,0.109025963 10.6988003,0 10.9728792,0 C11.2469581,0 11.5097798,0.109025963 11.7033792,0.303032408 C11.8961532,0.48667389 12.0052542,0.741288168 12.0052542,1.00753241 C12.0052542,1.27377665 11.8961532,1.52839093 11.7033792,1.71203241 L4.70337922,8.70303241 C4.30041178,9.10574131 3.64734665,9.10574131 3.24437922,8.70303241 L0.303379218,5.71403241 C0.109700475,5.530478 0,5.27537258 0,5.00853241 C0,4.74169224 0.109700475,4.48658681 0.303379218,4.30303241 C0.706346652,3.9003235 1.35941178,3.9003235 1.76237922,4.30303241 L4.00337922,6.49403241 L10.2423792,0.303032408 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcheckallall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.checkall.all.f6fdb44d32d01d9c24e9228ea02abb43.svg";